// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/tarjeta-fidelidad-flights/list',
    name: 'tarjeta-fidelidad-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/TarjetasFidelidad.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_tarjeta_fidelidad_flights',
    },
  },
]

export default formTable
